module.exports = __webpack_public_path__ + "img/hdnj-pic1.6dcf4975.png";